import React from "react";
import PayoutTimesheetCompactRow from "./PayoutTimesheetCompactRow";

/**
 * Renders a compact payout timesheet table.
 *
 * @param {Object} props - Component props.
 * @param {Array<Object>} props.timesheets - Timesheet rows.
 * @param {Function} props.onSelect - Row click handler.
 * @param {boolean} props.quickBooksExported - Whether QuickBooks was exported for the week.
 * @param {string} props.emptyMessage - Empty table message.
 * @returns {JSX.Element} Compact payout table.
 */
const PayoutTimesheetCompactTable = ({
  timesheets = [],
  onSelect,
  quickBooksExported = false,
  emptyMessage = "No timesheets found.",
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full table-fixed divide-y divide-gray-100">
        <colgroup>
          <col className="w-[20%]" />
          <col className="w-[6%]" />
          <col className="w-[10%]" />
          <col className="w-[10%]" />
          <col className="w-[10%]" />
          <col className="w-[11%]" />
          <col className="w-[11%]" />
          <col className="w-[10%]" />
          <col className="w-[12%]" />
        </colgroup>
        <thead className="bg-gray-100">
          <tr className="whitespace-nowrap text-[11px] uppercase tracking-wide text-gray-500">
            <th className="px-3 py-2 text-left font-semibold">Worker</th>
            <th className="px-2 py-2 text-right font-semibold">Shifts</th>
            <th className="px-2 py-2 text-right font-semibold">Worker Hrs</th>
            <th className="px-2 py-2 text-right font-semibold">Manager Hrs</th>
            <th className="px-2 py-2 text-right font-semibold">Payout Hrs</th>
            <th
              className="px-2 py-2 text-right font-semibold"
              title="Difference between worker hours and manager hours."
            >
              Manager Delta
            </th>
            <th
              className="px-2 py-2 text-right font-semibold"
              title="Difference between worker hours and payout hours."
            >
              Payout Delta
            </th>
            <th
              className="px-2 py-2 text-right font-semibold"
              title="Most common project for this worker this week. Hover for full breakdown."
            >
              Primary Project
            </th>
            <th className="py-2 pl-6 pr-6 text-right font-semibold">Status</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {timesheets.length === 0 ? (
            <tr>
              <td colSpan={9} className="px-3 py-4 text-center text-sm text-gray-500">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            timesheets.map((timesheet) => (
              <PayoutTimesheetCompactRow
                key={timesheet.id}
                timesheet={timesheet}
                onSelect={onSelect}
                quickBooksExported={quickBooksExported}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PayoutTimesheetCompactTable;
